// extracted by mini-css-extract-plugin
export default {"wrapperMain":"profile_wrapperMain__OinrC","wrapper":"profile_wrapper__hZIWb","settings":"profile_settings__IF6zK"};